// extracted by mini-css-extract-plugin
module.exports = {"text":"_9RAK0_hu"};